import React from "react";
import Home from "./Home";
import AboutUs from "./AboutUs";
import AIInnovation2 from "./AIInnovation2";
import AboutUsLast from "./AboutUsLast";

const MainPage = () => {
  return (
    <div>
      <Home />
      <AboutUs />
      <AIInnovation2 />
      <AboutUsLast />
      {/* <AIInnovation/> */}
    </div>
  );
};

export default MainPage;
